import BarChartViz from '../vizs/BarChartViz'
import BaseComponent from './BaseComponent'
/**
 * # {componentLabel} (`class {componentClassName}`)
 * The stacked bar chart is used to display values across two or more categorical variables. Each bar is divided into a number of sub-bars stacked end to end, each one corresponding to a level of the second categorical variable.
 *
 * ### Example Usage
 * ```javascript
 *
 *   import {StackedBars} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new StackedBars($el, data, config);
 *
 * ```
 *
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 3 or more columns.
 *
 * Each row represents a stack. The first column should be the id/label of the stack, and the rest of the columns should represent each of the layers in the stack.
 *
 * | category   | value1 |  value2  |  value3  |
 * | --------   | ------ |  ------  |  ------  |
 * |   Jan      |    22.4|      15.4|      43.2|
 * |   Feb      |    52.3|      29.3|      12.8|
 * |   Mar      |    12.8|      34.1|      61.4|
 * |   Apr      |    26.0|      12.3|      14.5|
 *
 * {.data-table}
 *
 * Each layer will be assigned a different color, to distinguish them inside of each stack.
 *
 * */
export default class StackedBarsComponent extends BaseComponent {
  static vizClass = BarChartViz
  static componentLabel = 'Stacked Bar chart'
  static dataFormat = [
    { index: 0, axis: 'x0', types: [String], role: 'id', roleLabel: 'Category' },
    {
      index: -1,
      axis: 'y0',
      label: 'Stack',
      types: [Number, null],
      role: 'value',
      roleLabel: 'Stacked value',
    },
  ]
  static defaultConfig = {
    title: this.componentLabel,
    mode: 'stacked',
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'],
        nonEditable: true,
      },
    },
    /**
     * Show the TOTAL value on top of each stack.
     */
    showDatumValues: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    AxisHelper: {
      y: {
        trimThreshold: {
          nonEditable: true,
        },
      },
      x: {
        showTickValues: {
          nonEditable: true,
        },
      },
    },
    LegendBehavior: {
      showLegend: {
        value: true,
        nonEditable: false,
      },
    },
    TooltipBehavior: {
      getHtml: function (d) {
        return `
        <div class="tip-value important">${this.valueWithUnit(d.value, 'y')}</div>
        <div class="tip-id">
          <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
            { id: d.parentId }
          )}; margin-right: 3px"></span>
          ${d.parentId}
        </div>
        <div class="secondary">${this.formatValue(d.id, 'x')}</div>
        `
      },
    },
  }
}
